@if (!isCheckingUrl && isValidUrl) {
  <div class="container-fluid">
    <div class="container" style="margin-bottom: -20px;">
      <div class="HmsContainer">
        <div class="row HmsInsideContainer" role="banner" aria-label="1">
          <div class="text-center header-content" [innerHtml]="headerHtml">
          </div>
        </div>
        <div class="row HmsInsideContainer">
          <div class="col-md-12 button-padding-left">
            @if (isInstruction) {
              <button type="button" class="greyBtn" (click)="openInstruction()"
                style="font-weight: bold;">
                Instructions
              </button>
            }
          </div>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
}

@if (!isCheckingUrl && !isValidUrl) {
  <div class="centered-text">
    <h1> Invalid URL. Please verify the URL that you are attempting to access.</h1>
  </div>
}